/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import RoutingConstants from 'lib/RoutingConstants'
// import moment from 'moment'
import { get, put } from 'lib/api';
import { compareRecipeTime, getTimeStamp, differnceTimeStamp, getSelectedWeekDates, getWeekDays, sortByKey, formatTimeStamp } from 'lib/services';
import { onPressSaveBtn } from 'lib/common'
import LazyLoad from 'react-image-lazy-load';
// import InfiniteScroll from 'react-infinite-scroller';
import Loader from 'lib/loader';
import ReactResizeDetector from 'react-resize-detector';
import MobileDesign from 'lib/MobileDesign';
import moment from 'moment'
import shuffleObjArrays from 'shuffle-obj-arrays'
import RecipeHeader from './RecipeHeader';
import RecipeMobileHeader from './RecipeMobileHeader';
import history from '../../history'
import DisplaySwapRecipe from './DisplaySwapRecipe'
import BottomBar from './BottomBar';
import ViewMeal from '../dashboard/ViewMeal';
import DashHeader from '../dashboard/DashHeader';
import ViewSelectedRecipe from './ViewSelectedRecipe'

let randomCount = 0

let interval;
const RecipeList = props => (
  <div className="recipe-header">
    {props.action === undefined && <div className="recommendation">
      {/* <p> <strong>We Recommend:</strong> <span>{props.recipeRange} Recipes</span>  */}
      <p>
        <span className="mb_range">We recommend: 
          <span>{props.recipeRange} Recipes (typical week)</span></span>
        <a onClick={()=>props.openChat()} className=""> Stuck? Chat Us!</a></p>
      <span>Scroll through recipes or use the filters in the top right to discover delicious, healthy recipes!  </span>
    </div>}
    <div className="category-name">
      <h4> {!props.viewAllRecipeData && !props.applyFilters ? 'Featured Dishes' :  props.categoryName[0].name } </h4>
      {!props.viewAllRecipeData && !props.applyFilters && <a onClick={()=>props.viewAllRecipe()} className="clear-all-filtr">
          View all Recipes
      </a> }
    </div>
  </div>
)

class SelectRecipe extends Component {
  constructor(props) {
    super(props);
    const dataProps = this.props.location.state
    const inputs = dataProps ? dataProps.inputs : {};
    const recipeIndex = dataProps ? dataProps.recipeIndex : -1;
    const recipeArr = dataProps && dataProps.recipeArr !== undefined ? dataProps.recipeArr : [];
    const selectedRecipe = dataProps && dataProps.selectedRecipe !== undefined ? dataProps.selectedRecipe : {};
    
    const cookingDates = [];
    const dinnerDates = dataProps && dataProps.dinnerDates ? dataProps.dinnerDates : [];
    const lunchDates = dataProps && dataProps.lunchDates ? dataProps.lunchDates : [];
    const servingSize = dataProps && dataProps.servingSize ? dataProps.servingSize : 2;
    const from = dataProps && dataProps.from ? dataProps.from : null;
    
    const recipeCount = dataProps && dataProps.recipeCount !== undefined ? dataProps.recipeCount === 1 ?  2 : dataProps.recipeCount : 0;
    const slideClass = dataProps && dataProps.slideClass !== undefined ? dataProps.slideClass : ''
    const weekEndPoints = getSelectedWeekDates('currentWeek');
    const dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates: getWeekDays(weekEndPoints)
    const action = this.props.location.state && this.props.location.state.action !== undefined ? this.props.location.state.action: 'save'
    
    this.state = {
      count: 0,
      recipeArr,
      bottomClass: recipeArr.length > 0 ?'' : 'mb-hide',
      recipeData: [],
      proteins: [],
      veganProteins: [],
      equipments: [],
      diet: [],
      loadData:true,
      opaque: false,
      showRecipe: true,
      applyFilters: false,
      recipeDivClass: '',
      cookingDates,
      servingSize,
      lunchDates,
      dinnerDates,
      inputs,
      showBottom: true,
      equipmentsList: [],
      viewAllRecipe: false,
      nextOffset: 0,
      slideClass,
      recipeCount,
      recipelocation: {},
      showViewRecipe: false,
      showFilter: false,
      randomRecipe: true,
      dayDates,
      showMeal: false,
      cookDay: [],
      mealDay: [],
      mealArr: [{type:'Breakfast', recipe: []}, {type:'Lunch', recipe: []}, {type:'Dinner', recipe: []}],
      height: 200,
      recipeIds:[],
      action,
      from,
      recipeIndex,
      Featured: [],
      categoryNameData: [],
      recipeFilter: [],
      groceryCategory:['Produce','Dairy & Eggs','Meat & Seafood', 'Canned & Packaged', 'Spices & Condiments'],
      bundleRecipe: [],
      isBundle: false,
      bundleItems:{},
      selectedRecipe,
      dashState: dataProps.state
    };
  }

  componentWillMount() {
    window.scroll(0,0)
    this.getRecipesFilter()
    randomCount = 0
    document.body.style.overflow = "auto"
  }

  
  onPressCancel() {
    const { dayDates, dashState } = this.state
    sessionStorage.setItem('method', 'back')
    const dataProps = this.props.location.state
    dashState.vRData = dataProps.vRData
    history.push('dashboard',{ dayDates, bottomBtnState: dashState})
    // onPressCancelBtn(this.state, this.props.location.state)
  }

  onPressSave() {
    onPressSaveBtn(this.state, this.props.location.state)
  }
  
  // eslint-disable-next-line
  onPressNext(index, length) {
    const elmnt = document.getElementById(`myDiv${index}`);    
    const prevButton = document.getElementById(`next${index}`)
    const count = (6/1183) * window.innerWidth
    let value = '0px';
    if(elmnt.style.transform.indexOf('(') > -1) {
      value = elmnt.style.transform.split('(')[1]
    }
    elmnt.style.transform = `translateX(${value.split('p')[0] - (count*180)}px)`
    elmnt.style.transition = 'all 0.5s ease'
    value = elmnt.style.transform.split('(')[1]
    const width = value.split('-')[1]
 
    elmnt.style.width = `${width.split('p')[0]}%`
    if(value.split('p')[0] <= 0) {
      prevButton.childNodes[0].style.display = 'block'
    }
    if(value.indexOf('-') > -1 ){
      const divWidth = value.split('-')[1]
      if(((length-count)*180) < divWidth.split('p')[0]) {
        prevButton.childNodes[1].style.display = 'none'
      }
    }
  }

  // eslint-disable-next-line
  onPressBack(index) {
    const elmnt = document.getElementById(`myDiv${index}`);    
    const prevButton = document.getElementById(`next${index}`)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
    let value = '0px';
    if(elmnt.style.transform.indexOf('(') > -1) {
      value = elmnt.style.transform.split('(')[1]
    }

    const left = value.split('-')[1]
    const count = (6/1183) * window.innerWidth
    const translate = (count*180) - left.split('p')[0]
    elmnt.style.transform = `translateX(${translate}px)`
    elmnt.style.transition = 'all 0.5s ease'
    
    if(elmnt.style.transform.indexOf('(') > -1) {
      value = elmnt.style.transform.split('(')[1]
    }
    if(parseFloat(value.split('p')[0],0).toFixed(2) <= 0.00) {
      prevButton.childNodes[0].style.display = 'none'
    }
    if(value.split('p')[0] >= 0) {
      elmnt.style.margin = '0px 0 0 0px'; 
    }
  }
 
  onPressPrevious(){
    const { 
      servingSize, dayDates
    } = this.state
    document.body.style.overflow = ''
    document.ontouchmove = () => (true)
    const dataProps = this.props.location.state
    if(sessionStorage.getItem('path') === 'dashboard' && (dataProps && dataProps.path === 'dashboard')) {
      this.onPressCancel()
    } else {
      sessionStorage.removeItem('recipeArr')
      sessionStorage.removeItem('filter')
      sessionStorage.removeItem('viewAll')
      sessionStorage.removeItem('bottom')
      if (sessionStorage.getItem('plan') === 'create') {
        sessionStorage.setItem('method','back')
      }
      history.push('/dashboard',{dayDates, defaultServingSize: servingSize})
    }
  }

  onResize() {
    if(window.innerWidth < 768) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  }

  async getRecipes(filterData) {
    // const url = RoutingConstants.getRecipes;
    const recipeDataList = []
    let categoryNameList = []
    let { showBottom, action, cookDate } = this.state
    const { recipeArr, bottomClass, groceryCategory, inputs, bundleRecipe } = this.state
    let recipeIndex;
    const weekEndPoints = getSelectedWeekDates('currentWeek');
    const dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates: getWeekDays(weekEndPoints)
    const Featured = []
    await get(RoutingConstants.bundleRecipe,'contenful').then(response=>{
      response.items.map(item=>{
        const tagNameIndex = response.includes.Entry.findIndex(x=>x.sys.id === item.fields.bundleTag[0].sys.id)
        if(tagNameIndex > -1) {
          // console.log(item.fields.bundleTag[0].sys)
          if(inputs.vegan === 'no' && response.includes.Entry[tagNameIndex].fields.name.indexOf('Meat') > -1) {
            bundleRecipe.push(item)
          }else if(inputs.vegan === 'yes' && response.includes.Entry[tagNameIndex].fields.name.indexOf('Plant') > -1) {
            bundleRecipe.push(item)
          }     
        }
        return item
      })
      this.setState({ bundleRecipe })
    })
    await get(RoutingConstants.contentfulSelectRecipe,'contenful').then(response=>{
      categoryNameList = [
        {name: 'Featured Dishes',length:0,value:'Featured'},
        {name: 'Breakfast', length:0, value:'Breakfast'},
        // {name: 'Winner Winner Chicken Dinner', length: 0, value:'Chicken'},
        {name:'Quick Prep: Under 15 Mins Prep Time', length:0, value: 'Quick Prep'}, 
        {name:'One-Pan Meals For Easy Clean Up', length:0, value: "One-Pan"},
        {name: 'No Reheat Meals For Work', length:0, value: "No Reheat"},
        {name: "Bowls", length:0, value: "Bowl"},
        {name: "Soups", length:0, value: "Soup"},
        {name: "Salads", length:0, value: "Salad"},
        // {name: "Turkey Isn't Just For Thanksgiving", length:0, value: "Turkey"},
        // {name:'Pork - Get Piggy With It',length:0, value: "Pork"},
        // {name:"Beef...It's What's For Dinner", length:0, value: "Beef"},
        // {name:'Down By The Sea', length:0, value: "Fish"},
        {name:'South Of The Border', length:0, value: "Mexican"},
        {name:'Asian Zing', length:0, value: "Asian"},
        {name:'Flavors of Italy', length:0, value: "Italian"}
      ]
      
      response.items.map(itm=>{
        itm.fields.recipeId = itm.sys.id
        if(itm.fields.image){
          const imageIndex = response.includes.Asset.findIndex(x=>x.sys.id === itm.fields.image.sys.id)
          if(imageIndex > -1) {
            itm.fields.recipeImage = `https:${response.includes.Asset[imageIndex].fields.file.url}`
            
          }}
        
        itm.fields.recipeInstruction = []
        itm.fields.instructions.map(inst=>{
          const insIndex = response.includes.Entry.findIndex(x=>x.sys.id=== inst.sys.id)
          if(insIndex > -1) {
            itm.fields.recipeInstruction.push({instruction: response.includes.Entry[insIndex].fields.instructionText, id: inst.sys.id})
          }
          return inst;
        })

        itm.fields.recipeIngredient = []
        if(!itm.fields.recipeNutritionData)
          itm.fields.recipeNutritionData = []
        itm.fields.ingredientsData.map(ingd=>{
          const ingIndex = response.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
          if((ingIndex > -1) ) {
            
            const ingNameIndex = response.includes.Entry.findIndex(x=>x.sys.id === response.includes.Entry[ingIndex].fields.ingredient.sys.id)
            if(ingNameIndex > -1){
              let unit = response.includes.Entry[ingIndex].fields.unit
              unit = unit === 'empty' ? null : unit
              const groceryId = groceryCategory.findIndex(x=>x===response.includes.Entry[ingNameIndex].fields.groceryCategory)
              itm.fields.recipeIngredient.push({ 
                quantity: response.includes.Entry[ingIndex].fields.quantity, 
                id: ingd.sys.id, 
                unit,
                ingredient:{
                  name:response.includes.Entry[ingNameIndex].fields.name,
                  groceryId
                }
              })
            }
          }
          return ingd;
        })

        if(itm.fields.recipeSides && itm.fields.recipeSides.length > 0 ) {
          const sideIndex = response.items.findIndex(x=>x.sys.id === itm.fields.recipeSides[0].sys.id )
          if(sideIndex > -1) {
            itm.fields.sideRecipe = response.items[sideIndex].fields
            itm.fields.sideRecipe.sideId = response.items[sideIndex].sys.id
            if( response.items[sideIndex].fields &&  response.items[sideIndex].fields.image){
              const sideimageIndex = response.includes.Asset.findIndex(x=>x.sys.id === response.items[sideIndex].fields.image.sys.id)
              if(sideimageIndex > -1) {
                itm.fields.sideRecipe.recipeImage = `https:${response.includes.Asset[sideimageIndex].fields.file.url}`
              }
            }
            if(!itm.fields.sideRecipe.recipeNutritionData)
              itm.fields.sideReciperecipeNutritionData = []
            itm.fields.sideRecipe.recipeIngredient = []
            itm.fields.sideRecipe.ingredientsData.map(ingd=>{
              const ingIndex = response.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
              if((ingIndex > -1) ) {
                
                const ingNameIndex = response.includes.Entry.findIndex(x=>x.sys.id === response.includes.Entry[ingIndex].fields.ingredient.sys.id)
                if(ingNameIndex > -1){
                  let unit = response.includes.Entry[ingIndex].fields.unit
                  unit = unit === 'empty' ? null : unit
                  const groceryId = groceryCategory.findIndex(x=>x===response.includes.Entry[ingNameIndex].fields.groceryCategory)
              
                  itm.fields.sideRecipe.recipeIngredient.push({ 
                    quantity: response.includes.Entry[ingIndex].fields.quantity, 
                    id: ingd.sys.id, 
                    unit,
                    ingredient:{
                      name:response.includes.Entry[ingNameIndex].fields.name,
                      groceryId
                    }
                  })
                }
              }
              return ingd;
            })
            itm.fields.sideRecipe.recipeInstruction = []
            itm.fields.sideRecipe.instructions.map(inst=>{
              const insIndex = response.includes.Entry.findIndex(x=>x.sys.id=== inst.sys.id)
              if(insIndex > -1) {
                itm.fields.sideRecipe.recipeInstruction.push({instruction: response.includes.Entry[insIndex].fields.instructionText, id: inst.sys.id})
              }
              return inst;
            })
          }
        }
        
        if(itm.fields.equipmentTypes){
          const equipIndex = response.includes.Entry.findIndex(x=>x.sys.id=== itm.fields.equipmentTypes[0].sys.id)
          if(equipIndex > -1) {

            itm.fields.equipmentIcon = `/images/${response.includes.Entry[equipIndex].fields.icon}`
            itm.fields.equipmentName = response.includes.Entry[equipIndex].fields.title
          } else {
            itm.fields.equipmentIcon = `/images/none.svg`
          }
        }
        let vIndex = -1
        const vegIndex = filterData.proteins.findIndex(x=>x === itm.fields.proteinType) 
        if(vegIndex > -1) {
          vIndex = 0
        } else {
          vIndex = -1
        }
        if(itm.fields.breakfast && vIndex > -1) {
          const bIndex = categoryNameList.findIndex(x=>x.value === 'Breakfast')
          if(bIndex > -1 && !itm.fields.sideDish)
            categoryNameList[bIndex].length += 1
        }
        const categoryIndex = categoryNameList.findIndex(x=>x.value === itm.fields.proteinType) 
        
        if(categoryIndex > -1 && vIndex > -1 && !itm.fields.sideDish) {
          categoryNameList[categoryIndex].length += 1
        }
        itm.fields.tags = []
        if(itm.fields.tag) {
          itm.fields.tag.map(tagField=>{
            const tagIndex = response.includes.Entry.findIndex(x=>x.sys.id=== tagField.sys.id)
            if(tagIndex > -1) {
              tagField.sys.value = response.includes.Entry[tagIndex].fields.name
            }
            return null;
          })
          itm.fields.tags = itm.fields.tag
        }
        itm.fields.tags.map(tag=>{
          const cIndex = categoryNameList.findIndex(x=>x.value === tag.sys.value)
          if(cIndex > -1 && vIndex > -1 && !itm.fields.sideDish) {
            categoryNameList[cIndex].length += 1
          }
          return null
        })
        Featured.push(itm.fields)
        return null;
      })

      if(this.props.location.state && 
        this.props.location.state.path === 'dashboard'){
        sessionStorage.setItem('path', 'dashboard')
        showBottom = false
        recipeIndex = this.props.location.state.index
        action = this.props.location.state.action
        cookDate = this.props.location.state.cookDate
      }

      this.setState({ 
        recipeData: recipeDataList, loadData: false, 
        proteins: filterData.proteins, 
        veganProteins: filterData.veganProteins, 
        equipments: filterData.equipments,
        diet: filterData.diet,
        mealType: filterData.mealType,
        showBottom,
        recipeIndex,
        action,
        showRecipe : true,
        cookDate, dayDates, recipeArr,
        bottomClass,
        hasMore: false,
        viewAllRecipe: false,
        Featured,
        categoryName: categoryNameList
      })
    }).catch(()=>{
      this.setState({ loadData: false})
    })
  }
  

  getRecipesFilter() {
    const { inputs } = this.state
    const url = RoutingConstants.getFilterAttributes
    get(url).then(response => {
      const diet = ['Dairy-free','Gluten-free','Soy-free','Egg-free','Nut-free','Sugar-free','Fit&Nu']
      response.result.diet = diet
      response.result.veganProteins = ["Beans","Lentils","Tofu","Tempeh","None","Nuts"]
      if(inputs.vegan === 'yes'){
        response.result.proteins = ["Beans","Lentils","Tofu","Tempeh","None"]
      } else {
        response.result.proteins = ["Chicken","Beef","Pork","Turkey","Fish","Shell Fish","Mixed (meatballs, sausage, etc.)","None","Tofu", "Plant-Based"] 
      }
      this.getRecipes(response.result)
    }).catch(()=>{
      localStorage.removeItem('token');
      history.push('/login');
    })
  }
  

  recipeApiData(value) {
    const recipeApiData = JSON.parse(sessionStorage.getItem('recipeApi'))
    let { 
      showBottom, action, cookDate, recipeArr, showRecipe, recipeDivClass, 
      recipeCount, applyFilters, bottomClass, filterTags, equipmentsList, 
      viewAllRecipe, hasMore, cookDay, mealArr, recipeIds
    } = this.state
    let recipeIndex;
    const weekEndPoints = getSelectedWeekDates('currentWeek');
    const dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates: getWeekDays(weekEndPoints)
    const dataProps = this.props.location.state
    const slideClass = dataProps && dataProps.slideClass !== undefined ? dataProps.slideClass : ''
    if(dataProps && 
      dataProps.path === 'dashboard'){
      sessionStorage.setItem('path', 'dashboard')
      showBottom = false
      recipeIndex = dataProps.index
      action = dataProps.action
      cookDate = dataProps.cookDate
    } 
   
    if(sessionStorage.getItem('recipeArr') && sessionStorage.getItem('recipeArr').length > 0) {
      recipeArr = JSON.parse(sessionStorage.getItem('recipeArr'))
    }
    if(sessionStorage.getItem('bottom')) {
      const bottom = JSON.parse(sessionStorage.getItem('bottom'))
      showRecipe = bottom.showRecipe
      showBottom = bottom.showBottom
      recipeCount = bottom.recipeCount === 1 ? 2 : bottom.recipeCount
      bottomClass = recipeArr.length > 0 ? '' : 'mb-hide'
    }
    if(sessionStorage.getItem('viewAll')) {
      const allRecipeDataList = JSON.parse(sessionStorage.getItem('viewAll'))
      recipeApiData.recipeData = allRecipeDataList.recipeData
      recipeApiData.categoryName = allRecipeDataList.categoryName
      viewAllRecipe = true
      hasMore = true
      recipeDivClass='filter-rslt'
      this.setState({ recipeDivClass })
    }
    if(sessionStorage.getItem('filter')) {
      const filterDataList = JSON.parse(sessionStorage.getItem('filter'))
      recipeApiData.recipeData = filterDataList.recipeData
      recipeApiData.categoryName = filterDataList.categoryName
      showRecipe = filterDataList.showRecipe
      showBottom = filterDataList.showBottom
      filterTags = filterDataList.filterTags
      recipeDivClass = filterDataList.recipeDivClass
      equipmentsList = filterDataList.equipmentsList
      applyFilters = true
      hasMore = false
      this.setState({ recipeDivClass, applyFilters})
    }
    if(value === 'emptyfilter') {
      showRecipe = true
      applyFilters = false
      viewAllRecipe = false
      recipeDivClass=''
      hasMore= false
    } else if( value === 'viewAll') {
      showRecipe = true
      applyFilters = false
    }
    if(sessionStorage.getItem('planData')) {
      const flowData = JSON.parse(sessionStorage.getItem('planData'))
      cookDay = flowData.cookDay
      mealArr = flowData.mealArr
      recipeIds = flowData.recipeIds
      cookDay = cookDay.sort(sortByKey('cooking_date','asc'))
      // recipeArr = flowData.recipeArr
    }    
    this.setState({ 
      recipeData: recipeApiData.recipeData, 
      categoryName: recipeApiData.categoryName, 
      proteins: recipeApiData.proteins, 
      equipments: recipeApiData.equipments,
      diet: recipeApiData.diet,
      showBottom,
      recipeIndex,
      action,
      showRecipe,
      cookDate, dayDates, recipeArr,
      bottomClass,
      filterTags,
      equipmentsList,
      viewAllRecipe,
      hasMore,
      applyFilters,
      recipeCount,
      recipeDivClass,
      slideClass,
      cookDay, 
      mealArr,
      recipeIds,
    })
  }


  addMeal(event,key, image, rItems, id, totalHands, totalTime, calories, equipmentIcon, sideName) {
    const { count,  servingSize, recipeArr, recipeCount, isMobile, showMeal, inputs, action } = this.state
    let { bottomClass,  mode } = this.state
    const index =  recipeArr.findIndex(x => x.items.recipe_id === id)
    let recipeIndex = index
    
    const items = {recipe:rItems}
    if(rItems.sideRecipe){
      items.recipe.recipe_sides = [{recipe:rItems.sideRecipe}]
      items.sideId = rItems.sideRecipe.sideId
    } else {
      items.recipe.recipe_sides = []
    }
    // items.recipe.recipe_sides
    if(index > -1) {
      mode = 'edit'
    } else {
      recipeArr.push({index: event, image, key, items, servingSize, id, totalHands, totalTime, calories, equipmentIcon, sideName, recipe_id:id})
      mode = 'add'
      bottomClass = ''
      recipeIndex = recipeArr.length - 1
    }
     
    if(sessionStorage.getItem('recipeArr')) {
      sessionStorage.setItem('recipeArr', JSON.stringify(recipeArr))
    }
    this.setState({ count: count+1, recipeArr, bottomClass, recipeCount:recipeCount + 1,  mode, recipeIndex, isBundle: false })
    if(items && items.recipe){
      const email = localStorage.getItem('email')
      window.analytics.track(`Recipe Selected`, {
        recipeName: items.recipe.name,
        email
      });
    }
    

    if(!isMobile && action!== 'swap') {
      document.body.style.overflow = "hidden"
      inputs.cooking_data = []
      inputs.delete_user_cooking_dates = []
      inputs.meal_plan_data = []
      inputs.delete_meal_plan_schedule = []
      inputs.delete_cooking_recipe = []
      const newFlowData = { cookDay: this.state.cookDay, mealArr: this.state.mealArr, recipeIds: this.state.recipeIds, inputs}
      sessionStorage.setItem('planData', JSON.stringify(newFlowData))
      let height = this.state.height
      let bundle = 0
      let preBundle = 0
      let meal = 0
      let premeal = 0
      let preHeight = []
      this.state.cookDay.map((item)=>{
        if(item.recipe.length >= 1) {
          bundle = 0
          meal = 0
          preBundle = 0
          item.recipe.map((rcp, rcindex)=>{
            if((rcp.isBundle === 1) && (rcindex < 3)) {
              bundle += 1
            } else if(rcindex < 3) {
              meal +=1
            }
            // if(cIndex === 0) {
            preBundle = bundle
            premeal = meal
            // }
            return rcp;
          })
          const addBundle = preBundle > 0 ? preBundle * 60 : 0 
          const hei = (preBundle * 75)+(premeal*60) + addBundle + 75
          preHeight.push({height:`${hei}`})
          preHeight = preHeight.sort(sortByKey('height','desc'))

        }
        return item;
      })
      // const addBundle = preBundle > 0 ? preBundle * 60 : 0 
      height = preHeight[0] ? parseInt(preHeight[0].height,0) : 200
      height = height < 200 ? 200 : height
      this.setState({showMeal: !showMeal, height,  })
    } else if(action === 'swap') {
      // for swapRecipe functionality
      this.swapRecipe(recipeArr)
      console.log(recipeArr)

    }
    const dataProps = this.props.location ? this.props.location.state : null
    // dataProps.datesDay = dayDates
    dataProps.inputs = inputs
    dataProps.recipeIndex = recipeIndex
    dataProps.showRecipe = true
    
    dataProps.datesDay= JSON.stringify(dataProps.datesDay)
    dataProps.viewRecipe = false
    dataProps.recipeArr = recipeArr
    dataProps.recipeIds = this.state.recipeIds
    if(dataProps) {
      localStorage.setItem('rData',JSON.stringify(dataProps));
    }
  }

  addBundle(bundleItems, bundleHands, bundleTotalTime) {
    const { count,  servingSize, recipeCount, isMobile, showMeal, inputs, Featured } = this.state
    let {  mode, recipeArr } = this.state

    recipeArr = []
    bundleItems.bundleHands = bundleHands
    bundleItems.bundleTotalTime = bundleTotalTime
    // const index =  recipeArr.findIndex(x => x.items.recipe_id === id)
    // let recipeIndex = index
    bundleItems.bundleRecipe.map(bunRcp=>{
      const bunIndex = Featured.findIndex(x=>x.recipeId === bunRcp.sys.id)
      if(bunIndex > -1) {
        const items = {recipe: Featured[bunIndex]}
        const sideName = items.sideRecipe ? items.sideRecipe.name : null
        if(items.sideRecipe)
          items.recipe.recipe_sides = [{recipe:items.sideRecipe}]
        else {
          items.recipe.recipe_sides = []
        }
        recipeArr.push({image:items.recipe.recipeImage, items, servingSize, id: items.recipe.recipeId, bundleHands, bundleTotalTime, equipmentIcon: items.equipmentIcon, sideName})
        mode = 'add'
      }
      return null
    })
     
    if(sessionStorage.getItem('recipeArr')) {
      sessionStorage.setItem('recipeArr', JSON.stringify(recipeArr))
    }
    this.setState({ count: count+1, recipeArr,  recipeCount:recipeCount + 1,  mode, isBundle: true, bundleItems })
    if(bundleItems.name){
      const email = localStorage.getItem('email')
      window.analytics.track(`Bundle Recipe Selected`, {
        bundleName: bundleItems.name,
        email
      });
    }
    if(!isMobile) {
      document.body.style.overflow = "hidden"
      inputs.cooking_data = []
      inputs.delete_user_cooking_dates = []
      inputs.meal_plan_data = []
      inputs.delete_meal_plan_schedule = []
      inputs.delete_cooking_recipe = []
      
      const newFlowData = { cookDay: this.state.cookDay, mealArr: this.state.mealArr, recipeIds: this.state.recipeIds, inputs}
      sessionStorage.setItem('planData', JSON.stringify(newFlowData))
      this.setState({showMeal: !showMeal })
    }
    const dataProps = this.props.location ? this.props.location.state : null
    // dataProps.datesDay = dayDates
    dataProps.inputs = inputs
    dataProps.showRecipe = true    
    dataProps.datesDay= JSON.stringify(dataProps.datesDay)
    dataProps.viewRecipe = false
    dataProps.recipeArr = recipeArr
    dataProps.recipeIds = this.state.recipeIds
    if(dataProps) {
      localStorage.setItem('rData',JSON.stringify(dataProps));
    }
  }

  recipeList(data, value) {
    const { recipeIds } = this.state
    return data.map((recipeItem)=>{
    
      if(recipeItem.recipe){
        let image = recipeItem.recipe.image
        let thumbImage = recipeItem.recipe.image
        let tickDisplay = 'none'
        // let display = 'block'
        const id = recipeItem.recipe.id
        if(recipeIds.length > 0) {
          const recipeIndex = recipeIds.findIndex((
            x=>x.id === id 
          ))
          if(recipeIndex > -1) {
            // display = 'none'
            tickDisplay = 'block'
          } else {
            // display ='block'
            tickDisplay = 'none'
          }
        }
        let equipmentIcon;
        let sideName = null
        let sideHands = 0
        let sidePassive = 0
        let totalHands = recipeItem.recipe.hands_on_time || 0
        const recipePassive = recipeItem.recipe.passive_time || 0
        const totalRecipeTime = totalHands + recipePassive
        let totalSideTime = 0
        let calories = 0
        let totalPassive = recipePassive;
        const recipeName = 
        recipeItem.recipe.name
      
        if(recipeItem.recipe.image === null) {
          image = '/images/small.png';
          thumbImage = '/images/small.png';
        }
        const setImage = image
        if(recipeItem.recipe.image !== null) {
          const checkImage = recipeItem.recipe.image.includes('mpn-recipe-images/')
          if(checkImage){
            image = recipeItem.recipe.image.split('mpn-recipe-images/')[0];
            thumbImage = `${image}mpn-recipe-images/Images/${recipeItem.recipe.id}-EV300.jpg` 
            image += `mpn-recipe-images/Images/${recipeItem.recipe.id}-EH720.jpg` 
          }else{
            image = recipeItem.recipe.image.split('Images/')[0];
            thumbImage = `${image}Images/${recipeItem.recipe.id}-EV300.jpg` 
            image = setImage
          }          
        }
        if (recipeItem.recipe.recipe_equipment_type.length > 0) {
          equipmentIcon = `/images/${recipeItem.recipe.recipe_equipment_type[0].equipment_type.icon}`;
          if (equipmentIcon === '/images/') {
            equipmentIcon = '/images/none.svg';
          }
        } else {
          equipmentIcon = '/images/none.svg';
        }
        const calorieIndex = recipeItem.recipe.recipe_nutrition_data && recipeItem.recipe.recipe_nutrition_data.findIndex(x=>x.nutrition_info_attribute.attribute === 'Calories')
        if(calorieIndex > -1) {
          calories = parseInt(recipeItem.recipe.recipe_nutrition_data[calorieIndex].value,0)
        }
        if (recipeItem.recipe.recipe_sides.length > 0) {
          if (recipeItem.recipe.recipe_sides[0].recipe) {
            sideName = recipeItem.recipe.recipe_sides[0].recipe.name
            sideHands = recipeItem.recipe.recipe_sides[0].recipe.hands_on_time || 0
            sidePassive = recipeItem.recipe.recipe_sides[0].recipe.passive_time || 0
            totalHands += sideHands
            totalSideTime = sideHands + sidePassive
            totalPassive += sidePassive
            const caloriesIndex = recipeItem.recipe.recipe_sides[0].recipe_nutrition_data && recipeItem.recipe.recipe_sides[0].recipe_nutrition_data.findIndex(x=>x.nutrition_info_attribute.attribute === 'Calories')
            if(caloriesIndex > -1) {
              calories += parseInt(recipeItem.recipe.recipe_sides[0].recipe_nutrition_data[caloriesIndex].value,0)
            }
          }
        } 
        let totalTime = compareRecipeTime(totalRecipeTime, totalSideTime);
        totalTime = compareRecipeTime(totalTime, totalHands);
        totalHands = getTimeStamp(totalHands)
        totalTime = getTimeStamp(totalTime)
        totalPassive = differnceTimeStamp(totalTime, totalHands.split('m')[0])
        totalPassive = getTimeStamp(totalPassive)
        const laterAddOn = {
          index:`add-meal-btn${value}${id}`,id:`add-meal-btn${value}${id}`, image:thumbImage, items:recipeItem,
          key:`add-meal-btn${value}${recipeItem.recipe.id}`
        }
        return(
          <div className="meal-post" key={`${value}${recipeItem.recipe.name}`} >
            <a 
              draggable={false} 
              className="add-meal-btn" 
              id={`add-meal-btn${value}${id}`} 
              onClick={()=>this.addMeal(
                `add-meal-btn${value}${id}`,id, thumbImage,recipeItem, 
                `add-meal-btn${value}${recipeItem.recipe.id}`, totalHands, totalTime, calories, equipmentIcon, sideName
              )} 
              style={{ height:'auto' }}
            >
              <div style={{display: tickDisplay}} className="added-tag">
                <span> Added </span>
              </div> 
              <img src="/images/add.svg" alt=""/>
            </a>
            <div  onClick={()=>this.viewRecipe(totalHands, totalTime, totalPassive, recipeItem.recipe.name, sideName, recipeItem.recipe, laterAddOn )}>
              <a>
                <LazyLoad
                  loaderImage
                  originalSrc={image}
                  offsetLeft={window.innerWidth}
                  offsetHorizontal={360}
                  height={120}
                  imageProps={{
                    src: '/images/small.png',
                    draggable: false,
                    name: 'd.',
                  }}
                  className='recipe_img'

                />
                <div className="select-meals-title-cntnt">
                  <h5>{recipeName}</h5>
                  <p className="aftr-hdng">{sideName}</p>
                </div>
                <div className="meal-post-data">
                  <div className="meal-post-data-box meal-post-data-img">
                    <img
                      src={equipmentIcon}
                      className="equipment-icn"
                      alt="icon"
                    />
                  </div>
                  <div className="meal-post-data-box">
                    <img src="/images/hands.svg" alt="" className="hands-svg"/>
                    {totalHands}
                  </div>
                  <div className="meal-post-data-box time-est">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
										 viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve">
                      <g>
                        <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                        <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
                      </g>
                    </svg>
                    {totalTime}</div>
                </div>
              </a>
            </div>
          </div>
        )
      }
      return '';
    })
  }

  // eslint-disable-next-line
  showButton(event,name, length) {
    const { applyFilters, viewAllRecipe } = this.state
    if(!applyFilters && !viewAllRecipe){
      const button = document.getElementById(event)
      const elem = document.getElementById(name)
      button.childNodes[1].style.display = 'block'

      let value = '0'
      if(elem && elem.style.transform.indexOf('(') > -1) {
        value = elem.style.transform.split('(')[1]
      }
      
      if(value.split('p')[0] < '0' && parseFloat(value.split('p')[0],0).toFixed(3) < (-0.005)) {
        button.childNodes[0].style.display = 'block'
      }
      if(parseInt(window.innerWidth/180,0) > length) {
        button.childNodes[1].style.display = 'none'
      } 
      const count = (6/1299) * window.innerWidth
      if(value.indexOf('-') > -1 ){
        const divWidth = value.split('-')[1]
        if(((length-count)*180) <= divWidth.split('p')[0]) {
          button.childNodes[1].style.display = 'none'
        }
      }
    }
  }

  hideButton(event) {
    const { applyFilters } = this.state
    if(!applyFilters) {
      const button = document.getElementById(event)
      button.childNodes[1].style.display = 'none'
      button.childNodes[0].style.display = 'none'
    }
  }

  divOpaque() {
    let { opacity, opaque } = this.state
    let proteinelem = false ;
    let cookingelem = false ;
    let dietelem = false ;
    let mealelem = false ;

    if(document.getElementById('proteindrp')) {
      proteinelem = document.getElementById('proteindrp').getAttribute('aria-expanded')
    } 
    if(document.getElementById('mealtypedrp')) {
      mealelem = document.getElementById('mealtypedrp').getAttribute('aria-expanded')
    } 
    if(document.getElementById('cookingdrp')) {
      cookingelem = document.getElementById('cookingdrp').getAttribute('aria-expanded')
    }
    if(document.getElementById('dietdrp')) {
      dietelem = document.getElementById('dietdrp').getAttribute('aria-expanded')
    }
    if(proteinelem === 'true' || cookingelem === 'true' || dietelem === 'true' || mealelem === 'true') {  
      opaque = !opaque
      opacity = 0.5
    } else {
      opaque = false
      opacity = 1
    }
    this.setState({ opaque, opacity })
  }

  viewRecipe(totalHandsOn, totalTime, totalPassive, rname, sname, recipe, laterAddOn, isBundle) {
    const {
      servingSize, recipeArr, recipeData, recipeDivClass, recipeCount,
      categoryName, showRecipe, applyFilters, filterTags, showBottom, equipmentsList, 
      viewAllRecipe, inputs
    } = this.state
    
    const email = localStorage.getItem('email')
    sessionStorage.setItem('recipeArr', JSON.stringify(recipeArr))
    const bottom = { showBottom, showRecipe, recipeCount}
    sessionStorage.setItem('bottom', JSON.stringify(bottom))
    if (applyFilters) {
      const filterData = { recipeData,
        categoryName,
        showRecipe,
        showBottom,
        recipeDivClass,
        filterTags,
        equipmentsList,
      }

      sessionStorage.setItem('filter', JSON.stringify(filterData))
    }
    laterAddOn.servingSize = servingSize
    laterAddOn.totalHands = totalHandsOn
    laterAddOn.totalTime = totalTime
    const dataProps = this.props.location ? this.props.location.state : null
    // dataProps.datesDay = dayDates
    dataProps.inputs = inputs
    dataProps.recipeIndex = this.state.recipeIndex
    
    // dataProps.datesDay= JSON.stringify(dataProps.datesDay)
    dataProps.viewRecipe = true
    dataProps.recipeArr = recipeArr
    dataProps.recipeIds = this.state.recipeIds
    if(dataProps) {
      localStorage.setItem('rData',JSON.stringify(dataProps));
    }
    if (viewAllRecipe) {
      const allRecipeData = { 
        recipeData,
        categoryName,
        showRecipe,
        showBottom,
        recipeDivClass,
      }
      sessionStorage.setItem('viewAll', JSON.stringify(allRecipeData))
    }
    window.analytics.track(`View Details`, {
      recipeName: rname,
      email
    });
    const recipelocation ={ state:{ 
      path:'viewRecipe', totalHandsOn, totalTime, totalPassive, rname, sname, isBundle,
      recipe, totalServing: servingSize, laterAddOn, state:this.state, props:this.props.location.state
    }}
    document.getElementsByTagName('body')[0].className = 'modal-open'
    document.body.style.overflow = 'hidden'
    this.setState({ recipelocation, showViewRecipe: true })
  }

  // viewAll() {
  //   const { recipeArr, showBottom, showRecipe, viewAllRecipe, applyFilters, recipeCount } = this.state
  //   sessionStorage.setItem('recipeArr', JSON.stringify(recipeArr))
  //   const bottom = { showBottom, showRecipe, recipeCount}
  //   sessionStorage.setItem('bottom', JSON.stringify(bottom))
  //   sessionStorage.removeItem('filter')
  //   // const value = !viewAllRecipe || !applyFilters ? 'emptyfilter' : 'viewAll'
  //   if(!viewAllRecipe || !applyFilters) {
  //     sessionStorage.removeItem('viewAll')
  //   }
  //   
  // }


  showRecipe() {
    const { showFilter } = this.state
    let { recipeCount } = this.state
    recipeCount = recipeCount === 1 ? 2 : recipeCount
    this.setState({ showFilter: !showFilter, recipeCount})
  }

  closeMeal(data, recipeCount) {
    
    recipeCount = recipeCount === 1 ? 2 : recipeCount
    this.setState({ recipeArr: data, recipeCount})
    const timeOut = window.innerWidth < 769 ? 700 :0
    document.getElementById('modal-dialog').style.overflowY = 'hidden'
    localStorage.removeItem('rData')
    setTimeout(()=>{this.setState({showViewRecipe: false})}, timeOut)
  }

  // filter function
  async applyRecipeFilters(data) {
    randomCount = 0
    const { viewAllRecipe, recipeData, categoryName, showBottom, recipeDivClass, showRecipe, offset, hasMore} = this.state
    this.setState({ applyFilters: true, loadData: true, hasMore: false, showFilter: false })
    document.ontouchmove = () => (true)
    document.body.style.overflow = ''
    const recipeFilter = data
    const param = {}
    const categoryFilter = []
    param.proteins = data.proteinsData
    param.equipment = data.equipmentsData
    param.tags = data.tagsData
    
    data.mealTypes = []
    data.mealTypeData.map((mealData,index)=>{
      if(mealData === 'Breakfast') {
        data.mealTypes[index] = true
      } else {
        data.mealTypes[index] = false
      }
      return null
    })
    param.mealTypes = data.mealTypeData
    if (viewAllRecipe) {
      const allRecipeData = { 
        recipeData,
        categoryName,
        showRecipe,
        showBottom,
        recipeDivClass,
        offset,
        hasMore
      }
      sessionStorage.setItem('viewAll', JSON.stringify(allRecipeData))
    }
    categoryFilter.push({name:'Results From Your Filters'})
    this.setState({ 
      recipeFilter, 
      recipeDivClass: 'filter-rslt',
      loadData: false,
      filterTags: data,
      veganProteins: ["Beans","Lentils","Tofu","Tempeh","None","Nuts"]
    })
    return null
  }

  // view all Recipe function
  viewAllRecipe(offset) {
    if(offset === 0) {
      this.setState({ loadData: true }) 
    }
    const text = window.innerWidth > 768  ? `You're Viewing All Recipes` : 'Viewing All Recipes'
    const categoryFilter = [{name:text}]
    this.setState({ 
      categoryName: categoryFilter, 
      showRecipe: true,
      recipeDivClass: 'filter-rslt',
      loadData: false,
      opacity: 1,
      opaque: false,
      viewAllRecipe: true,
      applyFilters: false
    })    
  }

  async removeFilter(data) {
    this.setState({ recipeDivClass: '', applyFilters: false, showRecipe: true, opacity:1, recipeFilter: [] })
    randomCount = 0
    if(sessionStorage.getItem('recipeApi')) {
      await this.recipeApiData('emptyfilter')
    } else {
      await this.getRecipes(data)
    }
  }

  emptyRecipeArr() {
    const { recipeArr } = this.state
    if(document.getElementById(recipeArr[0].index)) {
      document.getElementById(recipeArr[0].index).style.display = 'block'
      if(document.getElementById(`${recipeArr[0].index}${recipeArr[0].key}`))
        document.getElementById(`${recipeArr[0].index}${recipeArr[0].key}`).style.display = 'none'
    }
    this.setState({recipeArr:[]})
    sessionStorage.removeItem('recipeArr')
  }

  // eslint-disable-next-line
  componentDidMount() {
    // const { inputs } = this.state
    let { cookDay, mealArr, recipeIds, inputs } = this.state
    // const { cookDay, height } = this.state
    const activeChat = this.props.location.state && this.props.location.state.path === 'dashboard'
    if(document.getElementById('PureChatWidget') === null && window.innerWidth < 768 && !activeChat) {
      interval = setInterval(()=>this.openChatBox(),1000)
    }
    // alert(inputs.user_weekly_schedule_id)
    const dataProps = this.props.location.state
    if(inputs.user_weekly_schedule_id && !sessionStorage.getItem('planData')) { 
      cookDay = dataProps.cookDay
      mealArr = dataProps.mealArr
      recipeIds = dataProps.recipeIds
    }
    if(sessionStorage.getItem('planData')) {
      const flowData = JSON.parse(sessionStorage.getItem('planData'))
      cookDay = flowData.cookDay
      inputs = flowData.inputs
      mealArr = flowData.mealArr
      recipeIds = flowData.recipeIds
      cookDay = cookDay.sort(sortByKey('cooking_date','asc'))
    }    
    
    // eslint-disable-next-line
    this.setState({ cookDay, mealArr, recipeIds })
  }

   

  // eslint-disable-next-line
  openChatBox() {
    if(document.getElementsByClassName('purechat-collapsed-image')[0]) {
      document.getElementById('PureChatWidget').classList.add('text')
      document.getElementsByClassName('purechat-collapsed-image')[0].removeAttribute('style')
    }
    if(document.getElementById('PureChatWidget') !== null) { 
      clearInterval(interval)
    }
  }

  closeRecipe(mode, calories) {
    const { recipeArr } = this.state
    let { showViewRecipe } = this.state
    
    const flowData = JSON.parse(sessionStorage.getItem('planData'))
    if(mode === 'add')
      recipeArr.pop()
    if(calories === 'view') {
      showViewRecipe = true
      document.body.style.overflow = "none"
    } else {
      document.body.style.overflow = "auto"
    }
    this.setState({ showMeal: false, recipeArr, mealArr: flowData.mealArr,height:200, cookDay: flowData.cookDay, recipeIds: flowData.recipeIds, showViewRecipe })
  }

  saveRecipe(cookDay, mealDay, mealArr, height, recipeIds, inputs) {
    const { recipeArr } = this.state
    recipeArr.map((ids,index)=>{
      
      const rIndex = recipeIds.findIndex(x=>x.recipe_id === ids.recipe_id)
      if(rIndex === -1) {
        recipeArr.splice(index , 1)
      }
      return ids.count
    })
    inputs.cooking_data = []
    inputs.delete_user_cooking_dates = []
    inputs.meal_plan_data = []
    inputs.update_meal_schedule = []
    inputs.delete_meal_plan_schedule = []
    inputs.delete_cooking_recipe = []
    
    const newFlowData = {
      cookDay,
      mealArr,
      recipeIds,
      inputs
    }
    sessionStorage.setItem('planData',JSON.stringify(newFlowData))
    document.body.style.overflow = "auto"
    this.setState({ cookDay, mealDay, showMeal: false, mealArr, height, action:'save' , recipeIds, inputs})
  }

  featuredRecipe() {
    const { Featured, categoryName, recipeDivClass, recipeIds, proteins } = this.state
    return categoryName.map((category, cIndex)=>{
      // const fIndex = item.tags.findIndex(x=>x.sys.value==="soy-free")
      // if(fIndex > -1) 
      if(randomCount === 0) {
        shuffleObjArrays({Featured})
      }
      randomCount += 1
      const categoryClass = window.innerWidth < 768 && categoryName.length === 1 ?
        'mb-hide' : ''
      if(category.length > 0)
        return(
          <div className="dishes-row-box" key={category.name} 
            onMouseOver={()=>this.showButton(`next${cIndex+1}`, `myDiv${cIndex+1}`, category.length)} 
            onMouseOut={()=>this.hideButton(`next${cIndex+1}`, `myDiv${cIndex+1}`)}
            onClick={()=>this.divOpaque('')} >
            <div className="container">
              <h4 className={categoryClass}>{category.name}</h4>
              <div className="next-back-btns" id={`next${cIndex+1}`}>
                <a className="back" onClick={()=>this.onPressBack(cIndex+1)} style={{display:'none'}}>&lt;</a> 
                <a className="next" onClick={()=>this.onPressNext(cIndex+1, category.length)} style={{display:'none'}}> &gt; </a>
              </div>
             
              <div className={`cal-days-cntnt dishes-row ${recipeDivClass}`} id={`myDiv${cIndex+1}`}>
                {
                  Featured.map((item, index)=>{ 
                    const sideDish = item.sideDish
                    const sideName = item.sideRecipe ? item.sideRecipe.name : null
                    let totalHands = item.handsOnTime
                    let totalTime = item.handsOnTime + item.passiveTime
                    let tickDisplay = 'none'
                    if(recipeIds.length > 0) {
                      const recipeIndex = recipeIds.findIndex((
                        x=>x.id === item.recipeId && x.type === 'meal'
                      ))
                      if(recipeIndex > -1) {
                        tickDisplay = 'block'
                      } 
                    }
                    if(item.sideRecipe) {
                      totalHands += item.sideRecipe.handsOnTime
                      const totalSideTime = item.sideRecipe.handsOnTime + item.sideRecipe.passiveTime
                      totalTime = compareRecipeTime(totalTime, totalSideTime);
                    }
                    totalTime = compareRecipeTime(totalTime, totalHands);
                    totalHands = getTimeStamp(totalHands)
                    totalTime = getTimeStamp(totalTime)
                  
                    let fIndex = item.tags.findIndex(x=>x.sys.value===category.value)
                    let vIndex = -1
                    if(category.value === 'Breakfast') {
                      fIndex = item.breakfast ? 0 : -1
                    } else if(category.value === item.proteinType) {
                      fIndex = 0
                    }
                    if(category.value === "Fish" && item.proteinType === 'Shell Fish'){
                      fIndex = 0
                    }
                    // if(inputs.vegan === 'yes') {
                    const vegIndex = proteins.findIndex(x=>x === item.proteinType) 
                    if(vegIndex > -1) {
                      vIndex = 0
                    
                    } else {
                      vIndex = -1
                    }
                    
                    const laterAddOn = {
                      index:`add-meal-btn${'value'}${item.recipeId}`,id:`add-meal-btn${'value'}${item.recipeId}`, image:item.recipeImage, 
                      items:item,
                      key:`add-meal-btn${'value'}${item.recipeId}`
                    }
                    let totalPassive = differnceTimeStamp(totalTime, totalHands.split('m')[0])
                    totalPassive = getTimeStamp(totalPassive)
                    if((!sideDish) && (fIndex > -1) && (vIndex > -1)) {
                      return(
                      // addMeal(event,key, image, items, id, totalHands, totalTime, calories, equipmentIcon, sideName) {
                        <div className="meal-post" key={`contentFul${index}`}>
                          <a 
                            className="add-meal-btn" 
                            onClick={()=>this.addMeal(
                              `add-meal-btn${'value'}${item.recipeId}`, 
                              `add-meal-btn${'value'}${item.recipeId}`, item.recipeImage, item, item.recipeId, totalHands, totalTime, 0, item.equipmentIcon, sideName
                            )} 
                            style={{ height:'auto' }}
                          >
                            <div style={{display: tickDisplay}} className="added-tag">
                              <span> Added </span>
                            </div> 
                            <img src="/images/add.svg" alt=""/>
                          </a>
                          <div onClick={()=>this.viewRecipe(totalHands, totalTime, totalPassive, item.name, sideName, item, laterAddOn, 0 )}>
                            <a>
                                
                              <LazyLoad
                                loaderImage
                                originalSrc={item.recipeImage}
                                offsetLeft={window.innerWidth}
                                offsetHorizontal={360}
                                height={120}
                                imageProps={{
                                  src: '/images/small.png',
                                  draggable: false,
                                  name: 'd.',
                                }}
                                className='recipe_img'
      
                              />
                              <div className="select-meals-title-cntnt">
                                <h5>{item.name}</h5>
                                {sideName && <p className="aftr-hdng">{sideName}</p>}
                              </div>
                              <div className="meal-post-data">
                                <div className="meal-post-data-box meal-post-data-img">
                                  <img
                                    src={item.equipmentIcon}
                                    className="equipment-icn"
                                    alt="icon"
                                  />
                                </div>
                                <div className="meal-post-data-box">
                                  <img src="/images/hands.svg" alt="" className="hands-svg"/>
                                  {totalHands}
                                </div>
                                <div className="meal-post-data-box time-est">
                                  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                                    viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve">
                                    <g>
                                      <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                                      <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
                                    </g>
                                  </svg>
                                  {totalTime}</div>
                              </div>
                            </a>
                          </div>
                
                        </div>
                      )} 
                    return null
                      
                  }
                  )
                }
              </div>
              {/* <span>{item.name}</span> */}
            </div>
          </div> 
        )
      return null    
    }
    )
  }
  
  viewContentRecipe() {
    // alert(value)
    const { Featured, recipeDivClass, recipeFilter, proteins, veganProteins, applyFilters, inputs } = this.state

    const text = applyFilters ? 'Results From Your Filters' : window.innerWidth > 768  ? `You're Viewing All Recipes` : 'Viewing All Recipes'
    return (
      <div className="dishes-row-box" key={text} onClick={()=>this.divOpaque('')} >
        <div className="container">
          <h4 className="">{text}</h4>
          <div className={`cal-days-cntnt dishes-row ${recipeDivClass}`} id={`myDiv${0+1}`}>
            {
              Featured.map((item, index)=>{ 
                const sideDish = item.sideDish
                const sideName = item.sideRecipe ? item.sideRecipe.name : null
                let totalHands = item.handsOnTime
                let totalTime = item.handsOnTime + item.passiveTime
                if(item.sideRecipe) {
                  totalHands += item.sideRecipe.handsOnTime
                  totalTime += item.handsOnTime + item.passiveTime
                }

                const laterAddOn = {
                  index:`add-meal-btn${'value'}${item.recipeId}`,id:`add-meal-btn${'value'}${item.recipeId}`, image:item.recipeImage, 
                  items:item,
                  key:`add-meal-btn${'value'}${item.recipeId}`
                }
                totalHands = getTimeStamp(totalHands)
                totalTime = getTimeStamp(totalTime)
                let totalPassive = differnceTimeStamp(totalTime, totalHands.split('m')[0])
                totalPassive = getTimeStamp(totalPassive)
                let fIndex = -1
                let mealIndex = 1
                let proteinIndex = 1
                let equipIndex = 1
                let dietIndex = 1
                if(recipeFilter.mealTypes && recipeFilter.mealTypes.length > 0) {
                  if(recipeFilter.mealTypes.length === 1) {
                    mealIndex = recipeFilter.mealTypes[0] === item.breakfast ? 1 : -1
                  } else {
                    mealIndex = 1
                  }
                } 
                if(recipeFilter.equipmentsData && recipeFilter.equipmentsData.length > 0) {
                  equipIndex = recipeFilter.equipmentsData.includes(item.equipmentName)  ? 1 : -1
                } 
                if(recipeFilter.tagsData && recipeFilter.tagsData.length > 0) {
                  dietIndex = 0
                  recipeFilter.tagsData.map(filterTag=>{
                    const matchTag = filterTag === 'Fit&Nu' ?  'fitandnu' : filterTag
                    if(dietIndex >= 0)
                      dietIndex = item.tags.findIndex(x=>x.sys.value === matchTag ) 
                    
                    return null
                  })
                } 
                
                if(recipeFilter.proteinsData && recipeFilter.proteinsData.length > 0) {
                  proteinIndex = recipeFilter.proteinsData.includes(item.proteinType)  ? 1 : -1
                  if(recipeFilter.proteinsData.includes('Plant-Based')) {
                    proteinIndex = veganProteins.findIndex(x=>x === item.proteinType) > -1 ? 1 : -1
                  }
                  // alert(proteinIndex)
                } 
                if(mealIndex === 1 && equipIndex === 1 && proteinIndex === 1 && dietIndex !== -1) {
                  fIndex = 0
                }

                let vIndex = 0
                const vegIndex = proteins.findIndex(x=>x === item.proteinType) 
                if(vegIndex > -1) {
                  vIndex = 0
                } else {
                  vIndex = -1
                }
                // }
                if(item.proteinType === "None" && inputs.vegan === 'yes') {
                  if(applyFilters && ((recipeFilter.proteinsData.length > 0 && !recipeFilter.proteinsData.includes('None')) || ( recipeFilter.proteinsData.length === 0))){
                    vIndex = -1
                  } else if(applyFilters && (recipeFilter.proteinsData.length > 0 && recipeFilter.proteinsData.includes('None'))) {
                    vIndex = 1
                  } else {
                    vIndex =-1
                  }
                  
                }
                // if(pro)

                if(!sideDish && (fIndex > -1) && (vIndex > -1)) {
                  return(

                    <div className="meal-post" key={`contentFul${index}`}>
                      <a 
                        className="add-meal-btn"
                        onClick={()=>this.addMeal(
                          `add-meal-btn${'value'}${item.recipeId}`, 
                          `add-meal-btn${'value'}${item.recipeId}`, item.recipeImage, item, item.recipeId, totalHands, totalTime, 0, item.equipmentIcon, sideName
                        )} 
                        style={{ height:'auto' }}
                      >
                        <img src="/images/add.svg" alt=""/>
                      </a>
                      <div onClick={()=>this.viewRecipe(totalHands, totalTime, totalPassive, item.name, sideName, item, laterAddOn, 0 )}>
                        <a>
                          
                          <LazyLoad
                            loaderImage
                            originalSrc={item.recipeImage}
                            offsetLeft={window.innerWidth}
                            offsetHorizontal={360}
                            height={120}
                            imageProps={{
                              src: '/images/small.png',
                              draggable: false,
                              name: 'd.',
                            }}
                            className='recipe_img'

                          />
                          <div className="select-meals-title-cntnt">
                            <h5>{item.name}</h5>
                            {sideName && <p className="aftr-hdng">{sideName}</p>}
                          </div>
                          <div className="meal-post-data">
                            <div className="meal-post-data-box meal-post-data-img">
                              <img
                                src={item.equipmentIcon}
                                className="equipment-icn"
                                alt="icon"
                              />
                            </div>
                            <div className="meal-post-data-box">
                              <img src="/images/hands.svg" alt="" className="hands-svg"/>
                              {totalHands}
                            </div>
                            <div className="meal-post-data-box time-est">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
										            viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve">
                                <g>
                                  <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                                  <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
                                </g>
                              </svg>
                              {totalTime}</div>
                          </div>
                        </a>
                      </div>
          
                    </div>
                  )} 
                return null
              }
              )}
          </div>
        </div>
      </div> 
    )
  }

  bundleRecipe() {
    const { recipeDivClass, Featured, recipeIds, bundleRecipe } = this.state
    return(
      <div className="dishes-row-box" key='bundles' 
        onMouseOver={()=>this.showButton(`next${-1}`, `myDiv${-1}`, bundleRecipe.length*3)} 
        onMouseOut={()=>this.hideButton(`next${-1}`, `myDiv${-1}`)}
        onClick={()=>this.divOpaque('')} >
        <div className="container">
          <h4 className=""> Bundles - 60min Prep Sessions  </h4>
          {/*  */}
          <div className="next-back-btns" id={`next${-1}`}>
            <a className="back" onClick={()=>this.onPressBack(-1)} style={{display:'none'}}>&lt;</a> 
            <a className="next" onClick={()=>this.onPressNext(-1, bundleRecipe.length*3)} style={{display:'none'}}> &gt; </a>
          </div>
          <div className={`cal-days-cntnt dishes-row ${recipeDivClass}`} id={`myDiv${-1}`}>
            {
              bundleRecipe.map(rcp=>{
                const bundleActiveTime = getTimeStamp(rcp.fields.bundleHandsOnTime)
                let  bundleTotalTime = rcp.fields.bundlePassiveTime + rcp.fields.bundleHandsOnTime
                bundleTotalTime= getTimeStamp(bundleTotalTime)
                const bundleRcp = rcp.fields.bundleRecipe
                rcp.fields.recipeId = rcp.sys.id
                let tickDisplay = 'none'
                if (recipeIds.findIndex(x=>x.id === rcp.sys.id) > -1) {
                  tickDisplay = 'block'
                }
                return(
                  <div className="bundle-rcp" key={rcp.fields.bundleTitle}>
                    <div className="bundle-hdng-left">
                      <div className="top-title">
                        <span style={{display: tickDisplay}} className="added-tag">
                          <span> Added </span>  
                        </span>
                        <h4> {rcp.fields.bundleTitle} </h4>
                      </div>
                      <div className="bundle-time">
                        <span> <b> Active: </b> {bundleActiveTime} </span>
                        <span> <b> Total Time: </b> {bundleTotalTime} </span>
                      </div>
                    </div>
                    <div className="bundle-hdng-rgt" onClick={()=>this.addBundle(rcp.fields, bundleActiveTime, bundleTotalTime)}> 
                      <img src="/images/add.svg" alt="" />
                    </div>
                    <div className="dishes-row">
                      {
                        bundleRcp.map(bunRcp=>{
                          const bunIndex = Featured.findIndex(x=>x.recipeId === bunRcp.sys.id)
                          if(bunIndex > -1) {
                            const item = Featured[bunIndex]
                          
                            // const sideDish = item.sideDish
                            const sideName = item.sideRecipe ? item.sideRecipe.name : null
                            let totalHands = item.handsOnTime
                            let totalTime = item.handsOnTime + item.passiveTime
                            // let tickDisplay = 'none'
                            if(recipeIds.length > 0) {
                              const recipeIndex = recipeIds.findIndex((
                                x=>x.id === item.recipeId
                              ))
                              if(recipeIndex > -1) {
                              // display = 'none'
                              // tickDisplay = 'block'
                              } 
                            }

                            if(item.sideRecipe) {
                              totalHands += item.sideRecipe.handsOnTime
                              const totalSideTime = item.sideRecipe.handsOnTime + item.sideRecipe.passiveTime
                              totalTime = compareRecipeTime(totalTime, totalSideTime);
                              
                            }
                            totalTime = compareRecipeTime(totalTime, totalHands);
                            totalHands = getTimeStamp(totalHands)
                            totalTime = getTimeStamp(totalTime)
                            const laterAddOn = {
                              index:`add-meal-btn${'value'}${item.recipeId}`,id:`add-meal-btn${'value'}${item.recipeId}`, image:item.recipeImage, 
                              items:item,
                              key:`add-meal-btn${'value'}${item.recipeId}`
                            }
          
                            let totalPassive = differnceTimeStamp(totalTime, totalHands.split('m')[0])
                            totalPassive = getTimeStamp(totalPassive)
                            return(
                              <div className="meal-post" key={`contentFulBundle${bunIndex}`}>
                              
                                <div 
                                  onClick={()=>this.viewRecipe(totalHands, totalTime, totalPassive, item.name, sideName, item, laterAddOn, rcp.isBundle )}
                                >
                                  <a>   
                                    <LazyLoad
                                      loaderImage
                                      originalSrc={item.recipeImage}
                                      offsetLeft={window.innerWidth}
                                      offsetHorizontal={360}
                                      height={80}
                                      imageProps={{
                                        src: '/images/small.png',
                                        draggable: false,
                                        name: 'd.',
                                      }}
                                      className='recipe_img'
              
                                    />
                                    <div className="select-meals-title-cntnt">
                                      <h5>{item.name}</h5>
                                    </div>
                                    <div className="meal-post-data">
                                      <div className="meal-post-data-box meal-post-data-img">
                                        <img
                                          src={item.equipmentIcon}
                                          className="equipment-icn"
                                          alt="icon"
                                        />
                                        {sideName && <p className="aftr-hdng">{sideName}</p>}
                                      </div>
                                    </div>
                                  </a>
                                </div>
                        
                              </div>
                            
                            )
                          }
                          return null;
                        })
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>

        </div> 
      </div> 
    )
  }

  showMeal(recipe, totalTime, totalHands, sideName) {
    const { action } = this.state
    if(action !== 'swap') {
      this.setState({ showMeal: true, showViewRecipe: false })
    } else {
      // this.setState({ showViewRecipe: false})
    } 
    this.addMeal(`addMeal${recipe.recipeId}`, `addMeal${recipe.recipeId}`, recipe.recipeImage, recipe, recipe.recipeId, totalHands, totalTime, 'view', recipe.equipmentIcon, sideName)
  }

  swapRecipe(recipeArr) {
    this.setState({ loadData: true })
    const { inputs, dashState, mealArr, dayDates, recipeIds, cookDay } = this.state
    const url = RoutingConstants.editNewPlan
    const params = { }
    const vRData = dashState.vRData
    const rindex = vRData.popupIndex.split('type')
    
    params.week_start_date = inputs.week_start_date
    params.week_end_date = inputs.week_end_date
    params.user_weekly_schedule_id = inputs.user_weekly_schedule_id
    params.cooking_data = []
    params.delete_user_cooking_dates = []
    params.meal_plan_data = []
    params.delete_meal_plan_schedule = []
    params.delete_cooking_recipe = []
    
    const idIndex = recipeIds.findIndex(x=>x.id === mealArr[rindex[0]].recipe[rindex[1]].recipe_id && x.type === 'meal')
    if(idIndex > -1) {
      // if(recipeIds[idIndex].count === 1) {
      //   recipeIds.splice(idIndex,1)
      // } else {
      // recipeIds[idIndex].count -=1
      if(recipeIds[idIndex].size > 0)
        recipeIds[idIndex].size -= mealArr[rindex[0]].recipe[rindex[1]].servingSize
      // }
    }
    const updateIdIndex = recipeIds.findIndex(x=>x.id === recipeArr[0].items.recipe.recipeId) 
    const addCount = mealArr[rindex[0]].recipe[rindex[1]].cookDay !=null ? 2 : 1
    // alert(addCount)
    if(updateIdIndex > -1) {
      recipeIds[updateIdIndex].count +=addCount
      recipeIds[updateIdIndex].size += mealArr[rindex[0]].recipe[rindex[1]].servingSize
    } else {
      recipeIds.push({ id:recipeArr[0].items.recipe.recipeId, count: addCount, size: mealArr[rindex[0]].recipe[rindex[1]].servingSize, type:'meal' })
    }
    
    params.update_meal_schedule = [{
      id:mealArr[rindex[0]].recipe[rindex[1]].id,
      recipe_id: recipeArr[0].recipe_id,
      side_dish_id: recipeArr[0].items.sideId ? recipeArr[0].items.sideId : null ,
      serving_size: mealArr[rindex[0]].recipe[rindex[1]].recipeData.servingSize,
      isBundle: mealArr[rindex[0]].recipe[rindex[1]].recipeData.isBundle
    }]
    
    let cookCount = 0;
    let cookDayIndex = null
    let cookIndex = -1

    const cIndex = mealArr[rindex[0]].recipe[rindex[1]].cookIndex
    if(mealArr[rindex[0]].recipe[rindex[1]].cookDay !=null) {
      const cookRIndex = cookDay[cIndex].recipe.findIndex(x=>x.recipe_id === recipeArr[0].items.recipe.recipeId)
      if(cookRIndex === -1) {
        cookDay[cIndex].recipe.push({
          name: recipeArr[0].items.recipe.name,
          recipe_id: recipeArr[0].items.recipe.recipeId,
          activeTime: recipeArr[0].totalHands,
          totalTime: recipeArr[0].totalTime ,
          equipmentIcon: recipeArr[0].equipmentIcon,
          recipe: recipeArr[0].items.recipe,
          servingSize: recipeArr[0].servingSize,
          side_dish_id: recipeArr[0].items.sideId ? recipeArr[0].items.sideId : null,
          sideRecipe: recipeArr[0].items.recipe.sideRecipe,
          isBundle:0,
          bundleRecipe:{}
          // recipeImg
        })
        cookDay[cIndex].totalHands = formatTimeStamp(cookDay[cIndex].totalHands)
        cookDay[cIndex].totalHands += formatTimeStamp(recipeArr[0].totalHands)
        cookDay[cIndex].totalHands = getTimeStamp(cookDay[cIndex].totalHands)
        params.cooking_data.push({
          cooking_date:cookDay[cIndex].cooking_date,
          recipes:[{
            recipe_id: recipeArr[0].items.recipe.recipeId,
            side_dish_id: recipeArr[0].items.sideId ? recipeArr[0].items.sideId : null,
            serving_size: recipeArr[0].servingSize,
            isBundle : 0
          }]
        })
      }
    }
    
    cookDay.map((cookdate,index)=>{
      // const rId = isBundle ? bundleItems.recipeId: recipeArr[rcpLength].items.recipe.recipeId
      const rcpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === recipeArr[0].items.recipe.recipeId )
      if(rcpIndex > -1 && cookCount === 0 ) {
        cookCount += 1;
        cookDayIndex = cookdate.cooking_day
        cookIndex = index
      }
      // alert(index)
      return null;
    })
    let result = -1
    if(cookDay[cookIndex]){
      const startDate = moment(cookDay[cookIndex].cooking_date)
      const endDate = moment(mealArr[rindex[0]].recipe[rindex[1]].meal_date)
      result = endDate.diff(startDate,'days')
    }


    
    // alert(mealArr[rindex[0]].recipe[rindex[1]].cookDay)
    const fromRecipe = mealArr[rindex[0]].recipe[rindex[1]].name
    const toRecipe = recipeArr[0].items.recipe.name
    const fromId = mealArr[rindex[0]].recipe[rindex[1]].recipe_id
    const toId = recipeArr[0].items.recipe.recipeId
    mealArr[rindex[0]].recipe[rindex[1]].name = recipeArr[0].items.recipe.name
    mealArr[rindex[0]].recipe[rindex[1]].recipe = recipeArr[0].items.recipe
    mealArr[rindex[0]].recipe[rindex[1]].sideName = recipeArr[0].sideName
    mealArr[rindex[0]].recipe[rindex[1]].recipe_id = recipeArr[0].items.recipe.recipeId
    mealArr[rindex[0]].recipe[rindex[1]].image =  recipeArr[0].image
    mealArr[rindex[0]].recipe[rindex[1]].cookDay = result >=0 ?  cookDayIndex: null
    mealArr[rindex[0]].recipe[rindex[1]].cookIndex = result >=0 ? cookIndex : null
    
    mealArr[rindex[0]].recipe[rindex[1]].recipeData.items = { recipe: recipeArr[0].items.recipe}
    mealArr[rindex[0]].recipe[rindex[1]].recipeData.recipe_sides = recipeArr[0].items.recipe.sideRecipe ? recipeArr[0].items.recipe.sideRecipe : null
    mealArr[rindex[0]].recipe[rindex[1]].recipeData.totalHands = recipeArr[0].totalHands
    mealArr[rindex[0]].recipe[rindex[1]].recipeData.totalTime = recipeArr[0].totalTime
    
    
    
    const groceryData = []
    mealArr.map(item=>{
      item.recipe.map(rcp=>{
        // console.log(console.log(rcp.servingSize),'meal')
        if(rcp.recipe){
          rcp.recipe.recipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);  
            value.unit = value.unit ? value.unit : null    
            const gIndex = groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
        }
        if(rcp.recipe && rcp.recipe.sideRecipe) {
          // console.log(rcp.servingSize)
          rcp.recipe.sideRecipe.recipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);      
            value.unit = value.unit ? value.unit : null
            const gIndex = groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
        }
        return null;
      })
      return null;
    })
    
    params.groceryData = groceryData
    put(url,params).then((response)=>{
      
      response.data.cooking_schedule.map(item=>{
        if(cIndex!=null && cookDay[cIndex] ){
          item.recipe.map(rcp=>{
            const rcpIndex = cookDay[cIndex].recipe.findIndex(x=>x.recipe_id === rcp.recipe_id)
            if(rcpIndex > -1) {
              cookDay[cookIndex].recipe[rcpIndex].id = rcp.id
              if(!cookDay[cookIndex].cooking_id)
                cookDay[cookIndex].cooking_id = rcp.user_cooking_date_id
            }
            return rcp
          })
        }
        return item
      })

      dashState.mealArr = mealArr
      dashState.cookDay = cookDay
      dashState.recipeIds = recipeIds
      dashState.vRData.recipeData = recipeArr[0]
      dashState.vRData.cookIndex = cookIndex
      dashState.vRData.colorIndex = cookIndex
      dashState.vRData.recipeData.servingSize = mealArr[rindex[0]].recipe[rindex[1]].recipeData.servingSize
      dashState.vRData.recipeData.isBundle = 0
      const totalCountIndex = recipeIds.findIndex(x=>x.id === fromId && x.type ==='meal')
      const totalCount = recipeIds[totalCountIndex].count
      const swapData = {
        fromRecipe,
        toRecipe,
        fromId,
        toId,
        sideDishId: recipeArr[0].items.sideId ? recipeArr[0].items.sideId : null,
        cookIndex: cIndex,
        recipe: recipeArr[0].items.recipe,
        totalCount,
        recipeIds
      }
      // swapData = JSON.stringify(swapData)
      sessionStorage.setItem('swapData', JSON.stringify(swapData))
      sessionStorage.setItem('method', 'back');
      // alert
      history.push('dashboard',{ dayDates, bottomBtnState: dashState, swapData})
      // this.setState({ loadData: false })
    }).catch(()=>{
      this.setState({ loadData: false })
    })

  }

  render() { 
    const { 
      recipeRange, applyFilters, loadData, proteins, equipments, diet, opacity, showRecipe, action,
      showBottom,  viewAllRecipe, categoryName, recipelocation, dayDates, selectedRecipe, bundleRecipe, recipeIndex,
      showViewRecipe, slideClass, showFilter, isMobile, showMeal, recipeArr, inputs, recipeIds, Featured, bundleItems,
    } = this.state
    // const recipes = this.props.location.state && this.props.location.state.recipes
    const headingText = action === 'swap' ? 'Swapping Out This Recipe:' : 
      isMobile? 'Select Your Menu' : 'Select Recipes to Add to Your Plan'
    // const subHeadingText = !showBottom ? 
    //   'Select another recipe for your plan.' : window.innerWidth > 768 ?`We recommend you choose ${recipeRange} recipes.`: 'Choose your recipes for the week!'
    const subHeadingText = !showBottom ? 
      'Select another recipe for your plan.' : window.innerWidth > 768 ? 'Most ninjas choose between 3-5 recipes for their weekly meal plan.': 'Start building your meal plan!'
    const bottom = recipeIds.length > 0 ? '80px !important' : '0px'
    const recipeTitle = this.state.isBundle ? bundleItems.bundleTitle: recipeArr.length > 0 && recipeIndex > 0 && recipeArr[recipeIndex].items.recipe.name
    return (
      <div className={`wrapper ${slideClass}`} onClick={()=>this.divOpaque()}> 
        <title> Prep Day - &nbsp; 
          {
            showViewRecipe ?
              this.state.recipelocation.state.rname :
              showMeal?
                recipeTitle :
                'Library'
          }
        </title>
        <style>
          {`
          .intercom-namespace .intercom-2gyppn {
            bottom: ${bottom};
          }
          @media(min-width:320px) and (max-width:767px){
            #PureChatWidget { display: none !important;}
            #PureChatWidget.text { display: block !important;}
            #PureChatWidget.purechat.purechat-animation-bounceInDown{
              animation-name: none!important;
            }
            .intercom-namespace .intercom-8kxdjc {
              bottom: ${bottom};
            }
            #PureChatWidget.purechat.purechat-top-right {
              right: 56px !important;
              top: 60px !important;
              position:absolute!important;
            }
            #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-bottom-right .purechat-collapsed-image, #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-top-right .purechat-collapsed-image{ background-image: url("/images/chat-us.png") !important;
            opacity:0!important; height: 27px!important;
           width:144px !important; z-index: 9 !important; margin-bottom: -38.32px !important; margin-right: -34px !important;
          }
          #PureChatWidget.purechat.purechat-widget-expanded.purechat-top-right {
            top:90px!important;
          }
          }

          `}
        </style>
        {
          loadData &&
          <div className="loading">
            <Loader />
            <div className="modal-backdrop fade in" />
          </div>
        }
        {
          navigator.userAgent.match(/iPad/i) !== null &&
        <style>
          {`${MobileDesign.design}`}
        </style>
        }
        <ReactResizeDetector handleWidth handleHeight onResize={() => this.onResize()} />
        {
          isMobile &&
        <header>  
          <div className="container">
            <a href="/" className="mb-hide">
              <img src="/images/logo.png" alt="" />
            </a>
            <div className="slect-meal-top">
              <div className="top-back-row-comon-hdr">
                <a onClick={()=>this.onPressPrevious()}>  
                  <svg enableBackground="new 0 0 256 256" height="256px" id="Layer_1" version="1.1" viewBox="0 0 256 256" width="256px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <path d="M91.474,33.861l-89.6,89.6c-2.5,2.5-2.5,6.551,0,9.051l89.6,89.6c2.5,2.5,6.551,2.5,9.051,0s2.5-6.742,0-9.242L21.849,134  H249.6c3.535,0,6.4-2.466,6.4-6s-2.865-6-6.4-6H21.849l78.676-78.881c1.25-1.25,1.875-2.993,1.875-4.629s-0.625-3.326-1.875-4.576  C98.024,31.413,93.974,31.361,91.474,33.861z" />
                  </svg>
                </a>
              </div>
              <h1 className="mb-only"> {headingText} </h1>
              <p className="after-hdng mb-only">
                {subHeadingText}
              </p>
            </div>
          </div>
        </header>}
        
        {!isMobile &&
          <DashHeader
            dashClass=""
            groceryClass=""
            libraryClass="active"
            dayDates={this.state.dayDates}
            previous={this.state.previous}
          />
        }
        <div className="filter-dropdown-mb mb-only">
          <RecipeMobileHeader 
            proteins={proteins}
            equipments={equipments}
            diet={diet}
            showFilter={!showFilter}
            divOpaque={(value)=>this.divOpaque(value)}
            showRecipe={()=>this.showRecipe()}
            applyFilters={applyFilters}
            viewAllRecipeData={viewAllRecipe}
            viewAllRecipe={()=>this.viewAllRecipe(0)}
            applyRecipeFilters={(data, equipmentsList)=>this.applyRecipeFilters(data, equipmentsList)} 
            getRecipes={(data)=>this.removeFilter(data)}
          />
        </div>
        <section className="select-meal-cntnt choose-recipe-cntnt">
          <div className="container">
            {showRecipe && <div className="choose-recipe-cntnt-box">
              <h1 className="mb-hide">{headingText}</h1>
              {
                action === 'swap' &&
                <DisplaySwapRecipe recipeArr={selectedRecipe}/>
              }
              <div className="mb-hide">
                <RecipeHeader 
                  proteins={proteins}
                  equipments={equipments}
                  diet={diet}
                  divOpaque={(value)=>this.divOpaque(value)}
                  applyRecipeFilters={(data, equipmentsList)=>this.applyRecipeFilters(data, equipmentsList)}
                  viewAllRecipe={()=>this.viewAllRecipe(0)}
                  getRecipes={(data)=>this.removeFilter(data)}
                  viewAllRecipeData={viewAllRecipe}
                  applyFilters={applyFilters}
                />
              </div>
            </div>
            }
          </div>
         
          {showRecipe &&
          <div>
            <div className="mb-only">
              <RecipeList  
                viewAllRecipe={()=>this.viewAllRecipe(0)} 
                viewAllRecipeData={viewAllRecipe} 
                applyFilters={applyFilters}
                categoryName={categoryName}
                recipeRange={recipeRange}
                action={action}
                openChat={()=>this.openChatBox()}
              />
            </div>
            {(!applyFilters && !viewAllRecipe) ?
              <div style={{opacity, transition:'.5s'}} className="selct-rcipe">
                {bundleRecipe.length === 0 ||  action === 'swap'  ? null : this.bundleRecipe()}
                {Featured.length > 0 && this.featuredRecipe() }
              </div>:
              <div style={{opacity, transition:'.5s'}} className="selct-rcipe">
                {Featured.length > 0 && this.viewContentRecipe() }
              </div>
            }
            
          </div>
          }
          {recipeIds.length > 0 &&
            <BottomBar 
              removeRecipe={(event, key, image, items ,id)=>
                this.addMeal(event, key,image, items, id)}
              onPressCancel={()=>this.onPressCancel()}
              onPressSave={()=>this.onPressSave()}
              location="select"
              pathFrom='chooseRecipe'
              action={action}
              emptyRecipeArr={()=>this.emptyRecipeArr()}
              {...this.state}
            />
          }
        </section>
        {
          showViewRecipe &&
            <div id="schedule-popup" className="fullwidth_Modal modal fade in" role="dialog" style={{ display: 'block', overflowY:'hidden' }}>
              <div className="modal-dialog" id="modal-dialog">
                
                {/* <div className="modal-content edt-cook-popup" style={{background: 'transparent', boxShadow: 'none'}}> */}
                <ViewMeal 
                  location={recipelocation} 
                  closeMeal={(data,count)=>this.closeMeal(data, count)} dayDates={dayDates} 
                  showMeal={(recipe, totalTime, totalHands, sideName) => this.showMeal(recipe, totalTime, totalHands, sideName)}
                />
                {/* </div> */}
              </div>
            </div>
        }
        {
          showMeal &&
            <div id="schedule-popup" className="fullwidth_Modal modal fade in" role="dialog" style={{ display: 'block', overflowY:'hidden' }}>
              <div className="modal-dialog" id="modal-dialog" style={{background:"#fff"}}>
                {/* <div className="modal-content edt-cook-popup" style={{background: 'transparent', boxShadow: 'none'}}> */}
                <ViewSelectedRecipe 
                  recipeArr={recipeArr} 
                  onClose={(mode, cal)=>this.closeRecipe(mode, cal)} 
                  dayDates={dayDates}
                  cookDay={this.state.cookDay}
                  mealDay={this.state.mealDay}
                  mealArr={this.state.mealArr}
                  height={this.state.height}
                  mode={this.state.mode}
                  inputs={inputs}
                  recipeIndex={recipeIndex}
                  servingSize={this.state.servingSize}
                  recipeIds={recipeIds}
                  from={this.state.from}
                  bundleItems={bundleItems}
                  isBundle={this.state.isBundle}
                  saveRecipe={(cookDay, mealDay, mealArr, height, rIds, input)=>this.saveRecipe(cookDay, mealDay, mealArr, height, rIds, input)}
                />
                {/* </div> */}
              </div>
            </div>
        }
      </div>
    );
  }
}

export default SelectRecipe;



// WEBPACK FOOTER //
// ./src/components/recipeList/SelectRecipe.js